import { useContext } from 'react';

import { PictureInPictureContext } from '../picture-in-picture-context';
import type { PictureInPictureContextValue } from '../picture-in-picture-provider.types';

export function usePictureInPicture(): PictureInPictureContextValue {
  return useContext(PictureInPictureContext);
}
